import { render } from "./ListsConsents.vue?vue&type=template&id=b34d5fd6&scoped=true"
import script from "./ListsConsents.vue?vue&type=script&lang=ts"
export * from "./ListsConsents.vue?vue&type=script&lang=ts"

import "./ListsConsents.vue?vue&type=style&index=0&id=b34d5fd6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b34d5fd6"

export default script